<template>
  <div style="padding:10px;background-color: #F5F5F5;min-height: 100%">

    <Card  :bordered="false" :dis-hover="true" style="margin-bottom:10px;">
      <div style="text-align:left">
        <Row>
          <Col span="19">
            <Button type="primary" @click="load">刷新</Button>
          </Col>
          <Col span="5">
             <!--<Input search enter-button placeholder="输入关键词搜索" v-model="serch.key"  @on-search="load"/>-->
          </Col>
        </Row>
      </div>
    </Card>

    <Card :dis-hover="true">
      <Spin fix v-if="loading"></Spin>
      <el-table :data="list" size="small" style="width: 100%" >
        <el-table-column prop="uid" label="申领用户" width="160" :show-tooltip-when-overflow="true">
          <template slot-scope="scope">
            <span v-if="scope.row.user">
               <Avatar :src="scope.row.user.avatarUrl"/>
            &nbsp;
            {{scope.row.user.userName}}
            </span>
            <span v-else>
              {{scope.row.uid}}
            </span>

          </template>
        </el-table-column>
        <el-table-column prop="gsmc" label="公司名称" :show-tooltip-when-overflow="true"></el-table-column>
        <el-table-column prop="xm" label="姓名" :show-tooltip-when-overflow="true"></el-table-column>
        <el-table-column prop="zw" label="职位" :show-tooltip-when-overflow="true"></el-table-column>
        <el-table-column prop="sj" label="手机" :show-tooltip-when-overflow="true"></el-table-column>
        <el-table-column prop="yx" label="邮箱" :show-tooltip-when-overflow="true"></el-table-column>
        <el-table-column prop="bz" label="备注" :show-tooltip-when-overflow="true"></el-table-column>
        <el-table-column prop="ctime" label="申领时间" :show-tooltip-when-overflow="true"></el-table-column>
        <el-table-column prop="state" label="申领状态" :show-tooltip-when-overflow="true"></el-table-column>
        <el-table-column prop="msg" label="操作" width="80" fixed="right">
          <template slot-scope="scope">
            <a @click="m2.id=scope.row.id;m2.modal=true">详情</a>
            <!--<cite>|</cite>-->
            <!--<a @click="edit(scope.row.id)">编辑</a>-->
            <!--<cite>|</cite>-->
            <!--<a @click="remove(scope.row.id)">删除</a>-->
          </template>
        </el-table-column>
      </el-table>
    </Card>

    <Card  :bordered="false" dis-hover style="text-align: center;margin-top:10px">
      <Page :total="count" show-total :page="page" @on-page-size-change="limitChange"  show-elevator @on-change="change"  show-sizer :page-size-opts="[10, 30,50,100]"></Page>
    </Card>


    <Modal title="详细信息" v-model="m2.modal" width="60%">
      <SlyouhuiDetail :id="m2.id"></SlyouhuiDetail>
    </Modal>

  </div>
</template>

<script>
  import SlyouhuiDetail from './SlyouhuiDetail'
  export default {
    components:{SlyouhuiDetail},
    props:['sid'],
    data(){
      return{
        baseUrl:'/api/youhui/slyouhui/',
        list:[],
        page:1,
        count:0,
        limit:10,
        modal1:false,
        detail:{},
        serch:{
          key:''
        },
        m2:{
          modal:false,
          id:0,
        },
        loading:false,
      }
    },
    methods:{
      load(){
        let that = this;
        let params = [];
        if(this.serch.key){
          params.push('t.uid@like@'+this.serch.key);
        }
        params.push('t.sid@=@'+this.sid);
        that.loading = true;
        this.$axios.get(this.baseUrl+'findall?page='+this.page+'&limit='+this.limit+'&params='+params).then(function(rs){
          that.list = rs.data.data;
          that.count = rs.data.count;
          that.loading = false;
        });
      },
      limitChange(val){
        this.limit = val;
        this.load();
      },
      change(val){
        this.page = val;
        this.load();
      },
      save(){
        let that = this;
        let data = Object.assign({}, this.detail);
        this.$axios({url:this.baseUrl+'save',method:'post',data:this.$qs.stringify(data)}).then(function(rs){
          that.toast(rs.data);
          if(rs.data.success){
            that.detail = {};
          }
        });
      },
      edit(id){
        let that = this;
        this.$axios.get(this.baseUrl+'getById?id='+id).then(function(rs){
          that.detail = rs.data;
          that.modal1 = true;
        });
      },
      remove(id){
        this.$Modal.confirm({
          title: '系统提示',
          content: '确定要删除吗',
          onOk: () => {
            let that = this;
            this.$axios.get(this.baseUrl+'delete?ids='+id).then(function(rs){
              that.toast(rs.data);
            });
          },
        });
      },
      toast(data){
        if(data.success){
          this.load();
          this.$Message.success(data.msg);
        }else{
          this.$Message.error(data.msg);
        }
      }
    },
    created(){
      this.load();
    },
    watch:{
      sid:{
        handler(newValue, oldValue) {
          this.load();
        },
        deep: true
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/youhui/Slyouhui.vue